import React from 'react';
import TidyCalEmbed from '../TidyCalEmbed';
import SafeIcon from '../../common/SafeIcon';

export default function NeedReviewResult({ answers }) {
  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="bg-amber-50 border-l-4 border-amber-500 p-6 md:p-8 rounded-r-2xl mb-8 shadow-sm">
        <div className="flex items-start gap-4">
          <SafeIcon name="Clipboard" className="w-8 h-8 text-amber-600 flex-shrink-0 mt-1" />
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-amber-900 mb-2">
              Your Business Insurance Needs a Professional Review
            </h1>
            <p className="text-amber-800 text-lg">
              Things have changed - let's make sure your coverage kept up.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-xl p-6 md:p-10 mb-8">
        <h2 className="text-xl font-bold text-blue-900 mb-6">Key Findings:</h2>
        
        <div className="grid md:grid-cols-2 gap-4 mb-8">
          <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
            <span className="text-2xl mb-2 block">🔄</span>
            <p className="text-gray-800 text-sm font-medium">Your business has evolved, but your policy was written for a past version.</p>
          </div>
          <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
            <span className="text-2xl mb-2 block">❓</span>
            <p className="text-gray-800 text-sm font-medium">You have uncertainty about what your current policy actually covers.</p>
          </div>
        </div>

        <div className="mb-8">
          <h3 className="font-bold text-gray-900 mb-3">Common gaps we find after business changes:</h3>
          <ul className="space-y-2 text-gray-600">
            <li>✗ Hired employees → Workers' comp not added</li>
            <li>✗ Increased revenue → Coverage limits still at old levels</li>
            <li>✗ New location → Old policy doesn't cover new address</li>
            <li>✗ Added services → Professional liability needed but missing</li>
          </ul>
        </div>

        <div className="bg-blue-50 p-6 rounded-xl mb-8 border border-blue-100">
          <h3 className="font-bold text-blue-900 mb-2">What This Means:</h3>
          <p className="text-blue-800 text-sm">Your insurance policy is a snapshot of your business at ONE point in time. If your business changed but your insurance didn't, you likely have coverage gaps you don't even know about.</p>
        </div>

        <h3 className="text-xl font-bold text-blue-900 mb-4">Next Step: Complete Policy Review</h3>
        <p className="text-gray-600 mb-6">Let's review your coverage line-by-line, compare it to what you ACTUALLY need today, and explain everything in plain English (no jargon!).</p>
        
        <TidyCalEmbed />
      </div>
    </div>
  );
}